import report from '../../../apis/report';
import {
  FetchStaffAttendanceRangeParams,
  StaffAttendance
} from '../types/StaffAttendanceTypes';

const fetchStaffAttendanceRange = async ({
  school,
  fromDate,
  toDate,
  role,
  perPage = 1000
}: FetchStaffAttendanceRangeParams): Promise<StaffAttendance[]> => {
  const allData: StaffAttendance[] = [];
  let pageNo = 1;

  while (true) {
    const response = await report.fetchStaffAttendanceReport({
      school,
      fromDate,
      toDate,
      role,
      perPage,
      page: pageNo
    });

    const pageData = (response.data || []) as unknown as StaffAttendance[];
    allData.push(...pageData);
    if (!response?.hasMore) break;
    pageNo += 1;
  }

  return allData;
};

export { fetchStaffAttendanceRange };
